export default __webpack_public_path__ + "static/media/project-completed.4d6d4cff.svg";